import { render } from "./student-qa.vue?vue&type=template&id=46f40346"
import script from "./student-qa.vue?vue&type=script&lang=js"
export * from "./student-qa.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__